var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_graph",
    "data-name": "vuesax/outline/graph",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.132,14.063H4.844C1.628,14.063,0,12.241,0,8.638V4.931C0,3.613.155,1.727,1.524.694c1.15-.852,2.8-.917,5.244-.207a10.211,10.211,0,0,1,6.807,6.807c.71,2.428.646,4.095-.207,5.231C12.335,13.908,10.45,14.063,9.132,14.063ZM3.914,1.934a2,2,0,0,0-1.214.31C2.2,2.618,1.95,3.5,1.95,4.931v3.72c0,2.893,1.111,3.488,2.906,3.488H9.145c1.421,0,2.3-.245,2.687-.749.452-.594.413-1.783-.09-3.526a8.362,8.362,0,0,0-5.49-5.49A8.2,8.2,0,0,0,3.914,1.934Z",
    transform: "translate(14.531 2.406)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.685,25.18A12.71,12.71,0,0,1,10.153.019.982.982,0,0,1,11.3.768a.982.982,0,0,1-.749,1.15A10.777,10.777,0,1,0,23.289,14.6a.968.968,0,0,1,1.9.375A12.725,12.725,0,0,1,12.685,25.18Z",
    transform: "translate(1.614 4.205)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin1);
export default __webpack_public_path__ + "static/media/spin1.33942e40c19b0d3b2c84fde850747621.svg";
export { ForwardRef as ReactComponent };